package com.example.mystybag.common.model

import dev.icerock.moko.resources.ImageResource
import com.example.mystybag.core.resources.SRC

data class ChooseTakePhotoOrPickFileVisualModel(
    val text        : String            = "",
    val image       : ImageResource     = SRC.images.img_placeholder,
    val onClick     : () -> Unit        = {}
)